import { isErpDirectIntegrationEnabled } from '@/features/erpDirectIntegrationFeature';
import { canOverrideDynamicsEnvironment } from '@/lib/dynamicsEnvironment';

// Opções da integração direta com o ERP: configuração GLOBAL gravada no banco (tabela system_configuration; API:
// GET/PUT /orders/erp-integration-settings, qualquer usuário autenticado), só fora de produção. Sem configuração gravada vale o
// padrão: fluxo antigo (lambda e Magento), sem modo sombra.
export const canChangeErpIntegrationSettings = canOverrideDynamicsEnvironment && isErpDirectIntegrationEnabled;
